import React, { useState } from 'react';
import Fab from '@mui/material/Fab';
import Tooltip from '@mui/material/Tooltip';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import { useAuth } from '../../context/AuthContext';
import FeedbackDialog from './FeedbackDialog';

const FeedbackButton = () => {
  const { isAuthenticated } = useAuth();
  const [dialogOpen, setDialogOpen] = useState(false);

  // Show for all authenticated users
  if (!isAuthenticated) {
    return null;
  }

  return (
    <>
      <Tooltip title="Send Feedback" placement="left">
        <Fab
          color="primary"
          size="medium"
          onClick={() => setDialogOpen(true)}
          sx={{
            position: 'fixed',
            bottom: 24,
            right: 24,
            zIndex: 1000,
            boxShadow: '0 4px 12px rgba(59, 130, 246, 0.4)',
            '&:hover': {
              boxShadow: '0 6px 16px rgba(59, 130, 246, 0.5)',
            },
          }}
          aria-label="send feedback"
        >
          <ChatBubbleOutlineIcon />
        </Fab>
      </Tooltip>

      <FeedbackDialog open={dialogOpen} onClose={() => setDialogOpen(false)} />
    </>
  );
};

export default FeedbackButton;
